import { CustomPivotTabIdSeparator, PendingCustomPivotId, } from '../models/Constants';
import { CustomFilterType } from '../models/Filters';
export function getCustomPivotTabId(customPivot) {
    if (customPivot.customFilterType === CustomFilterType.Pending) {
        return PendingCustomPivotId;
    }
    else {
        return "".concat(customPivot.customFilterType.toString()).concat(CustomPivotTabIdSeparator).concat(customPivot.customFilterKey);
    }
}
//# sourceMappingURL=getCustomPivotTabId.js.map